/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-bind */
import { useState } from 'react';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Avatar, Flex, message, Upload } from 'antd-v5';
import ImgCrop from 'antd-img-crop';

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = file => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
};

export const UploadAvatar = ({ initials, ...rest }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(rest?.defaultValue || '');

  const handleChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, url => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      {loading ? <LoadingOutlined /> : initials}
    </button>
  );

  async function handleUpload({ file, onSuccess }) {
    try {
      const url = URL.createObjectURL(file);
      setImageUrl(url);
      if (onSuccess) {
        onSuccess(url, file);
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <Flex gap="middle" wrap>
      <ImgCrop rotationSlider>
        <Upload
          name="avatar"
          listType="picture-circle"
          className="avatar-uploader"
          showUploadList={false}
          beforeUpload={beforeUpload}
          onChange={handleChange}
          customRequest={handleUpload}
          {...rest}
        >
          <Avatar style={{ width: '100%', height: '100%', fontSize: '40px' }} src={imageUrl}>
            {uploadButton}
          </Avatar>
          {/* {imageUrl ? <A src={imageUrl} alt="avatar" style={{ width: '100%', borderRadius: '50%' }} /> : uploadButton} */}
          <div
            style={{
              backgroundColor: '#000',
              width: '42px',
              height: '42px',
              borderRadius: '50%',
              border: '3px solid white',
              zIndex: 10,
              position: 'absolute',
              marginTop: '75px',
              /* marginLeft: '33px', */
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src="https://dashboard-v2-images.s3.amazonaws.com/ic-camera.svg" />
          </div>
        </Upload>
      </ImgCrop>
    </Flex>
  );
};
